import {
	SWITCH_ACCOUNT_REDIRECT,
	SWITCH_ACCOUNT_DEFAULT_PATH
} from '@/store/mutation-types'

/** 切换账号后刷新并跳转到指定页面（默认精英榜） */
export function reloadAfterSwitchAccount(path = SWITCH_ACCOUNT_DEFAULT_PATH) {
	const targetPath = path.startsWith('/') ? path : `/${path}`
	sessionStorage.setItem(SWITCH_ACCOUNT_REDIRECT, targetPath)
	window.location.hash = `#${targetPath}`
	window.location.reload()
}

export function consumeSwitchAccountRedirect() {
	const redirect = sessionStorage.getItem(SWITCH_ACCOUNT_REDIRECT)
	if (redirect) {
		sessionStorage.removeItem(SWITCH_ACCOUNT_REDIRECT)
		return redirect.startsWith('/') ? redirect : `/${redirect}`
	}
	return null
}
